module.exports = __webpack_public_path__ + "img/faro.ae04edd6.png";